<div class="container">
  <mat-tab-group
    [selectedIndex]="selected.value"
    (selectedTabChange)="back($event)"
    >
    <mat-tab label="Ordenes de trabajo por ejecutar">
      <div style="width: 100%; margin-top: 30px">
        <data-table
          [columns]="columnasOT"
          [data]="dataOT"
          [configuration]="configurationOT"
          [reloadTable]="recargarTablaOT"
          [params]="params"
          [url]="urlTablaOT"
          (add)="agregarOT($event)"
          (closeOrder)="clickFilaOT($event)"
          (delete)="eliminarOT($event)"
          (edit)="editarOT($event)"
          (print)="print($event)"
          (sendEmail)="sendEmail($event)"
          (addComment)='addCommentService($event)'
          (view)="viewDetailService($event)"
          [headerFilters]="headerFilters"
          [roleId]="roleId"
          [moduleId]="3"
          [subModuleId]="7"
        ></data-table>
      </div>
    </mat-tab>

    @if (currentState == stateTab.DETAIL && selected.value == 1) {
      <mat-tab label="Detalle">
        <app-work-order-summary [workOrderDetails]="detailsClickRow">
        </app-work-order-summary>
      </mat-tab>
    }

    @if (currentState == stateTab.CLOSEOT && selected.value == 1) {
      <mat-tab label="Cierre O.T">
        <mat-card appearance="outlined" style="background-color: #ffffff7a">
          <mat-card-content class="mat-body-1">
            <app-close-order
              (bodyOrder)="getBodyOrder()"
              [orderId]="orderId"
            ></app-close-order>
          </mat-card-content>
        </mat-card>
      </mat-tab>
    }
  </mat-tab-group>
</div>
